// src/utils/logoutRedirect.js
export function ensureOrigin(base) {
  if (!base) return "";
  if (/^https?:\/\//i.test(base)) return base.replace(/\/+$/, "");
  const scheme = /^(localhost|127\.0\.0\.1)(:|$)/i.test(base)
    ? "http://"
    : "https://";
  return (scheme + base).replace(/\/+$/, "");
}

// src/utils/logoutRedirect.js
export function buildLogoutUrl(params = {}) {
  const base = getLogoutUrl(); // already absolute and points to /signin
  const url = new URL(base);

  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && String(v).trim() !== "") {
      url.searchParams.set(k, String(v));
    }
  });

  return url.toString();
}

export function resolveEnv() {
  const explicit = (
    import.meta.env?.VITE_ENV ||
    process.env?.REACT_APP_ENV ||
    ""
  ).toLowerCase();

  if (["local", "dev", "uat", "prod"].includes(explicit)) return explicit;

  const host = window.location.hostname.toLowerCase();
  if (host === "localhost" || host === "127.0.0.1") return "local";
  if (host.includes("dev")) return "dev";
  if (
    host.includes("test") ||
    host.includes("uat") ||
    host.includes("staging") ||
    host.includes("qa")
  )
    return "uat";
  return "prod";
}

export function getLogoutUrl() {
  const ENV_BASES = {
    local:
      ensureOrigin(import.meta.env?.VITE_LOCAL_BASE_URL) ||
      "http://localhost:4300",
    dev:
      ensureOrigin(import.meta.env?.VITE_DEV_BASE_URL) ||
      "https://talent-dev.mayamaya.ai",
    uat:
      ensureOrigin(import.meta.env?.VITE_UAT_BASE_URL) ||
      "https://talent-test.mayamaya.ai",
    prod:
      ensureOrigin(import.meta.env?.VITE_PROD_BASE_URL) ||
      "https://talent.mayamaya.ai",
  };

  const ENV_LOGOUT_PATHS = {
    local: import.meta.env?.VITE_LOCAL_LOGOUT_PATH || "/signin",
    dev: import.meta.env?.VITE_DEV_LOGOUT_PATH || "/signin",
    uat: import.meta.env?.VITE_UAT_LOGOUT_PATH || "/signin",
    prod: import.meta.env?.VITE_PROD_LOGOUT_PATH || "/signin",
  };

  const env = resolveEnv();
  const base = ENV_BASES[env] || ensureOrigin(window.location.origin);
  const path = ENV_LOGOUT_PATHS[env] || "/signin";
  return `${base}${path.startsWith("/") ? "" : "/"}${path}`;
}

// src/utils/logoutRedirect.js

export function isDeprecatedAuthRoute(loc = window.location) {
  const hostname = (loc?.hostname || "").toLowerCase();
  const port = String(loc?.port || "");
  const pathname = (loc?.pathname || "").toLowerCase().replace(/\/+$/, "");

  // Only these routes should show "page not found" + redirect
  const isAuthPath = pathname === "/signin" || pathname === "/signup";

  if (!isAuthPath) return false;

  const DEPRECATED_ORIGINS = [
    { host: "upskilling.mayamaya.us" },
    { host: "upskill-test-cgcyfzffb9hddab4.eastus-01.azurewebsites.net" },
    { host: "dev-console-v2.azurewebsites.net" },
    { host: "localhost", port: "4200" },
    { host: "127.0.0.1", port: "4200" },
  ];

  return DEPRECATED_ORIGINS.some((x) => {
    if (x.host !== hostname) return false;
    if (x.port && x.port !== port) return false;
    return true;
  });
}
